module.exports = __webpack_public_path__ + "img/bangzhu_1.409b3468.png";